module.exports = __webpack_public_path__ + "src/assets/img/page8/79a17bb543af7b4176daf358bfc9f485.jpg";